
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Photo Gallery</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm photo-gallery section-banner-bg-1">
    <div class="container">

        <div class="university campus-buzz">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <nav class="nav nav-pills d-flex justify-content-center mb-5">
                    <a href="javascript:void(0)" class="nav-link active"
                        (click)="filterInnerTabs('all', $event, 'inner-tab-events-neev')">All</a>
                    <a href="javascript:void(0)" class="nav-link"
                        (click)="filterInnerTabs('2026', $event, 'inner-tab-events-neev')">2026</a>
                    <a href="javascript:void(0)" class="nav-link"
                        (click)="filterInnerTabs('2025', $event, 'inner-tab-events-neev')">2025</a>
                    <a href="javascript:void(0)" class="nav-link"
                        (click)="filterInnerTabs('2024', $event, 'inner-tab-events-neev')">Past Years</a>
                    </nav>
                </div>
            </div>
            <div class="row row-cols-lg-1 row-cols-md-1 row-cols-1 justify-content-center g-3" id="inner-tab-events-neev">

                <div class="col" data-year="2026">
                   <div class="gall-ery" id="neev-26">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>NEEV - 2026 </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1h8pMH1xZinSuJHa13ecX2VoMUcQvP6bi" target="_blank" class="cmn-white-button">View More</a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-9.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-9.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-9.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-10.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-10.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-10.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-11.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-11.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-11.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-12.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-12.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-12.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-13.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-13.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-13.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-14.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-14.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-14.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-15.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-15.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-15.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-17.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-17.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-17.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-18.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-18.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-18.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-19.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-19.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-19.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-20.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-20.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-20.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-21.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-21.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-21.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-22.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-22.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-22.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-23.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-23.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-23.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-24.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-24.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-24.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-27.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-27.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-27.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                       
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-29.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-29.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-29.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-30.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-30.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-30.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-31.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-31.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-31.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-32.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-32.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-32.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-33.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-33.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-33.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-34.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-34.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-34.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-35.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-35.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-35.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-36.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-36.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-36.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-37.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-37.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-37.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-38.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-38.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-38.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-39.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-39.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-39.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-40.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-40.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-40.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-41.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-41.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev26/neev26-41.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col" data-year="2025">
                    <div class="gall-ery" id="geeto-ke-naam">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>एक शाम गीतों के नाम - 2025 </h4>
                                </div>
                            </div>
                            <!-- <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1h8pMH1xZinSuJHa13ecX2VoMUcQvP6bi" target="_blank" class="cmn-white-button">View More</a>
                            </div> -->
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ek-sham-geeto-k-naam/ek-sham-geeto-k-naam-6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="neev-25">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>NEEV - 2025 </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1h8pMH1xZinSuJHa13ecX2VoMUcQvP6bi" target="_blank" class="cmn-white-button">View More</a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-7.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-9.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-10.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-11.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-12.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-13.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-14.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/neev-25-15.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="kite-25">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                <h4>Kite Festival 2025</h4>
                            </div>
                        </div>
                        <!-- <div class="col-md-4 text-end">
                            <a href="https://drive.google.com/drive/folders/1Z_zbHO3fTIN9j9ai9vGehH6JjoOAUveQ" target="_blank" class="cmn-white-button">View More</a>
                        </div> -->

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-8.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-7.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                        <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-9.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                        <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-10.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                        <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-11.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>
                        <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/kite-25-5.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                            </div>
                        </a>
                    </li>

                        </ul>
                    </div>
                    </div>
                </div>

                <div class="col" data-year="2024">
                    <div class="gall-ery" id="gondiya">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>G H Raisoni Memorial Football Tournament - Gondia </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1Z_zbHO3fTIN9j9ai9vGehH6JjoOAUveQ" target="_blank" class="cmn-white-button">View More</a>
                            </div>
                            <!-- <div class="col-md-4 text-end">
                                <a
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div> -->
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic1.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic1.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic1.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic2.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic2.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic2.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic3.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic3.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic3.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic4.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic4.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic4.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic5.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic5.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic5.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic6.avif"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic6.avif">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic6.avif"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic7.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic7.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic7.avif"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic8.avif"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic8.avif">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/social_pic8.avif"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="classical-vocalist">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Aarti Ankalikar Indian Classical Vocalist - Nagpur </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/17sOQEiyE71uZBI8oFW2WvvRBE179rdYh " target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/vidushi-6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="tennis">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Table Tennis Tournament </h4>
                                </div>
                            </div>

                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tennis/tennis-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mangeshkar-yavatmal-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Lata Mangeshkar Yavatmal Event</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/17W6aHE-CGvbVt6C3-rjolRkCqqeuThLZ?usp=drive_link"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-yavatmal/lata-yavatmal8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="FutsalTournament">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Futsal Tournament</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href=" https://drive.google.com/drive/folders/1t86xgd-AqktS8a_f2AxPs7JYrLm18B_5?usp=drive_link"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="ArcheryNagpur">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Archery Tournament Nagpur</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/14K2cjGNXm7DfI5J9MGjYf6M95Cjj7jLj" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/ArcheryNagpur/archery_ngp8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="chesscompition">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Chess Tournament</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/18KDezxd79n0F7-B_QJahOPyUYSMqJ1Dq" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chesscompition/chesscomp8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="badminton-tournament">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Badminton Tournament</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1OT9Pgex6Ff_veM89gEPAhYZHaNybsZjG?usp=sharing"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_7.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/badminton/bad_8.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mangeshkar-betul-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Lata Mangeshakr Betul</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1dB8_aKqvvOXGhc2cPaZ5iVUO946S8UmZ" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-betul/betul_6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mangeshkar-chhindwara-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Lata Mangeshakr Chhindwara</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1m1AoU7SjEpl11epWqoWsvUnXgp7UNGJu" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-8.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-8.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-8.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-7.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-7.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-7.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-bhandara-6.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-bhandara-6.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-bhandara-6.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-chhinwada/lata-chidwara-1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="basketball">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Basket State Championship</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1HzaB9xHCx0XtjLzFAPv8V7ctLbI7FUW3" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="sanjeev-ngp">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Dance Nagpur Dance</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/19BZW3oYQpF1zsi2bMCNQwYciyRXMEipx" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd5.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/dnd6.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="sanjeev-ngp">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Indian Classical Vocal Performance Nagpur </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1rZagDiEsCjNXZ_oxHJOYOZ3CkjmWREqC" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-ngp5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="sanjeev-amt">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Indian Classical Vocal Performance Amravati </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1OGcnOMoJ-ULkaAmWW6R4_cWXRVESGxl8" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt5.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-amt6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>


                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="unforgettable-kk">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Unforgettable KK </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1uu0ZjzCMUuuN0_po4GhOPunV8QtNb0Oa?usp=share_link"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-5.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/kk-6.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mageshkar-bhandara-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Forever Lata : A Musical Tribute to Bharat Ratna Lata Mangeshkar Bhandara </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1N2PF-KDNfGdfbBzoHjfDluXrFFDhbWQD?usp=sharing"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-5.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-bhandara-6.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="sanjeev-abhyankar-nagpur">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Sanjeev Abhyankar Nagpur </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="sanjeev-abhyankar-amravati">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Sanjeev Abhyankar Amravati </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sanjeev-abhyankar2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mageshkar-wardha-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Forever Lata Wardha </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1wfRAhWLL8mnjWsSGqTD0dB7UjavwdNgB" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-wardha4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="lata-mageshkar-chandrapur-event">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Forever Lata Chandrapur </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/18RVJ_Z0bUOjCW882y-PEd-eDwi1K9dcN" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/lata-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="nrutyavishkar">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>NRUTYAVISHKAR GHRSCF </h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1le_Eiijx4zoqWNBFQhXnOZrp8R7npXVc" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar_ghrscf.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/nrutyavishkar-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="harshali-gautam">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Dance Workshop - Harshita Gautam</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1rK8lbIYYVT3n40xjZ-D-AgNRrZ_E1ibw" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/harshali-gautam-4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="itoohave-talent">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>I Too Have A Talent 2023</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1g15xB9zxJWbWX0t9qzUa6ib9hju1Xy8P" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/itoohave-talent-4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>
                    <div class="gall-ery" id="naad-ninaad">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Naad Ninaad</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1bxMPHWbDxToqi3Pwo0xKr_13-GUgSiOj" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/naad-ninaad4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>



                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="rumi-hai">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>Rumi Hai</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://www.youtube.com/embed/nhOjuXBPwiI" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai1.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai2.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai3.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/rumi-hai4.jpg"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="sawani-sathaye">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>CLASSICAL CONCLAVE BY SAWANI SHENDE SATHAYE</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1KN5N9gS_QDpj8Eryqh7L088spGnoEdON?usp=sharing"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/sawani-sathaye4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>RAAGAS TO RICHES BY URVASHI SHAH</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1Z_4m-6_G40DN7-ImF50_gq5HuZEzzfDV" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp."
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi5.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi5.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>


                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>JOSH (SUMMER CAMP S P)</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1a-_-vmGhh9vBHlLOy8LYQFZltSq1Q8Wo?usp=sharing"
                                    target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/josh4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm shadow-text-sm">
                                    <h4>A MUSICAL TRIBUTE TO BHARAT RATNA LATA MANGESHKAR</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1a0nFBjNbkJcudjy8M7njM6Sx3s77g_r1" target="_blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>EMPLOYEE SPORTS MEET 2022</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="employee-sport-meet" target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/lata_m2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sports-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>FIDE CHESS COMPETITION</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="fidechess-gallery" target="_blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>LOKMAT CHESS COMPETITION</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="javascript:void(0);" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>SWAR RANG</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="javascript:void(0);" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/swar-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>SHIVAJI JAYANTI</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/folders/1uM3TmRS7GGxSL_ZogR_jlNSjQD4yDAPv" target="blank"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/s-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>KONKAN KANYA BAND</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/u/0/folders/1C8lTgQydd5gISeMDV_TguxmSSnVfzwDN"
                                    target="blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/kk_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>VIDUSHI KALAPINI KOMKALI</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/u/0/folders/1gBpTg4nPo5sKjf9YyfcqzLaOHBaVN8fH"
                                    target="blank" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vidushi-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>I TOO LOVE MY NATION</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://amzn.to/2mqhZVh" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nation-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>


                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>GURU SMT. PRIYANKA ABHYANKAR</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://urlzs.com/cbHFp" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/guru-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>


                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>MANBHAVAN ASHADH</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://urlzs.com/hrd7A" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ma_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>MS. NIRALI KARTIK (SURMAYI SHYAM)</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://urlzs.com/JB7rg" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/nk_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>GANDHAR DESHPANDE & ADITYA MODAK (JUGALBANDI)</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://urlzs.com/rJ12V" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/ms-4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>SHRI. BHUPAL PANSHIKAR & SHRI. SANDESH POPATKAR</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/u/0/folders/18DI5crorBeGxangM-PnG1rIjYopF2lWw"
                                    target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/bhupal_4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="prasad-khaparde">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>PT. PRASAD KHAPARDE</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://urlzs.com/bkEoM" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/pk4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="aditi-upadhya">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>ADITI UPADHYA</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://photos.app.goo.gl/uFZ69378w4SR7nzs8" target="blanks"
                                    class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/au4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery" id="deviki-pandit">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>PT. PRASAD KHAPARDE & PT. DEVIKI PANDIT</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="https://drive.google.com/drive/u/0/folders/1-NM-jA0HN1nHISMff8B8Hv8LxngOXXKw"
                                    target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp6.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp6.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dp6.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>KITE FESTIVAL</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="kite-festival-gallery" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/k4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>SJAN & RAISONI ACHIEVERS AWARD</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="sjan-award-gallery" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/vv4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div class="gall-ery">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4>DHAMAAL DANDIYA</h4>
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <a href="dhamaal-dandiya-yearly" target="blanks" class="cmn-white-button"><span>
                                        View More</span>
                                </a>
                            </div>
                        </div>
                        <div class="lightBox--gallery">
                            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d1.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d1.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d1.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d2.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d2.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d2.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d3.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d3.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d3.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>
                                <li class="col"
                                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d4.webp"
                                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d4.webp">
                                    <a href="Javascript:void(0);">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/d4.webp"
                                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                        <div class="light-gallery-poster">
                                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </div>

       

       
    </div>
</section>
